import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { getToday } from '../helpers/datetime';

const SELECTED_DATE_STORAGE_KEY = 'questList_selectedDate';

const getStoredSelectedDate = (): dayjs.Dayjs => {
    try {
        const stored = sessionStorage.getItem(SELECTED_DATE_STORAGE_KEY);
        if (stored) {
            const parsed = dayjs(stored);
            if (parsed.isValid()) {
                return parsed;
            }
        }
    } catch (e) {
        // Ignore storage errors
    }
    return getToday();
};

export const useSelectedDateRestore = () => {
    const [selectedDate, setSelectedDate] = useState(getStoredSelectedDate);

    // Save selectedDate to sessionStorage when it changes
    useEffect(() => {
        try {
            sessionStorage.setItem(SELECTED_DATE_STORAGE_KEY, selectedDate.toISOString());
        } catch (e) {
            // Ignore storage errors
        }
    }, [selectedDate]);

    return [selectedDate, setSelectedDate] as const;
};
